import { render, staticRenderFns } from "./AdminBroadcastSchedulesCard.vue?vue&type=template&id=489fa784"
import script from "./AdminBroadcastSchedulesCard.vue?vue&type=script&lang=js"
export * from "./AdminBroadcastSchedulesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports